import { render, staticRenderFns } from "./HomeOpera.vue?vue&type=template&id=06a40154&"
import script from "./HomeOpera.vue?vue&type=script&lang=js&"
export * from "./HomeOpera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports